import { z } from "zod";

import { SiteControllerSettingNeppanInputSchema } from "@/lib/zod/__generated__/validation-schema";

export const siteControllerSettingNeppanInputZodSchema = SiteControllerSettingNeppanInputSchema.extend({
	password: z.string().min(1, { message: "パスワードは必須入力です" }).max(500),
});

export type SiteControllerSettingNeppanInputZodSchemaType = z.infer<typeof siteControllerSettingNeppanInputZodSchema>;
